import { useState, useRef, useEffect } from 'react';
import './QualidadeBanner.scss';
import { desktopImages } from '../../../../images';

const QualidadeBanner = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [contentPosition, setContentPosition] = useState(0);
  const menuItemsRefs = useRef([]);

  // Dados das abas com informações de cada item
  const tabsData = [
    {
      id: 'materias-primas',
      title: 'MATÉRIAS-PRIMAS PREMIUM',
      icon: desktopImages.IconMateriasPrimas,
      backgroundImage: desktopImages.BannerMateriasPrimas,
      content: {
        highlight: 'Do mundo para você.',
        description: 'Selecionamos matérias-primas de origem global, com pureza e eficácia comprovadas por estudos clínicos. O que há de melhor na ciência mundial chega até você, com a qualidade que faz a diferença na sua saúde e bem-estar.'
      }
    },
    {
      id: 'controle-qualidade',
      title: 'CONTROLE DE QUALIDADE',
      icon: desktopImages.IconControleQualidade,
      backgroundImage: desktopImages.BannerControleQualidade,
      content: {
        highlight: 'Ciência que cuida.',
        description: 'Em nossos laboratórios, cada fórmula passa por análises rigorosas. Equipamentos de alta precisão e processos detalhados garantem segurança, confiança e consistência em cada resultado.'
      }
    },
    {
      id: 'pesquisa-inovacao',
      title: 'PESQUISA E INOVAÇÃO',
      icon: desktopImages.IconPesquisaInovacao,
      backgroundImage: desktopImages.BannerPesquisaInovacao,
      content: {
        highlight: 'Inovar para transformar.',
        description: 'A inovação é parte da nossa essência. Já lançamos mais de 170 produtos e seguimos investindo em pesquisa e tecnologia, porque acreditamos na inovação como forma de transformar vidas.'
      }
    },
    {
      id: 'certificados',
      title: 'NOSSOS CERTIFICADOS',
      icon: desktopImages.IconCertificados,
      backgroundImage: desktopImages.BannerCertificados,
      type: 'image',
      image: desktopImages.ImagemCertificados
    }
  ];

  // Navegação básica
  const goToTab = (index) => {
    setActiveTab(index);
    updateContentPosition(index);
  };

  // Função para calcular e atualizar a posição do conteúdo
  const updateContentPosition = (tabIndex) => {
    // Verifica se é um dos itens com posição fixa específica
    if (tabIndex === 1) { // Controle de Qualidade
      setContentPosition(71.0625);
      return;
    }

    if (tabIndex === 2) { // Pesquisa e Inovação
      setContentPosition(142.602);
      return;
    }

    // Para os outros itens, mantém a lógica original
    if (menuItemsRefs.current[tabIndex]) {
      const menuItem = menuItemsRefs.current[tabIndex];
      const bannerContainer = menuItem.closest('.banner-container');
      const menuItemRect = menuItem.getBoundingClientRect();
      const containerRect = bannerContainer.getBoundingClientRect();

      // Calcula a posição do centro do item do menu em relação ao container
      const itemCenter = menuItemRect.top + (menuItemRect.height / 2) - containerRect.top;
      const containerCenter = containerRect.height / 2;

      // Ajusta a posição para que o conteúdo fique alinhado com o item do menu
      let offset = itemCenter - containerCenter;

      // Adiciona um offset extra para o primeiro item (Matérias-primas premium)
      if (tabIndex === 0) {
        offset += 60; // Desce 60px
      }

      setContentPosition(offset);
    }
  };

  // useEffect para calcular posição inicial e recalcular em redimensionamento
  useEffect(() => {
    // Pequeno delay para garantir que o DOM esteja renderizado
    setTimeout(() => {
      updateContentPosition(activeTab);
    }, 100);

    const handleResize = () => {
      updateContentPosition(activeTab);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [activeTab]);

  // useEffect para alternância automática dos menus a cada 3 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTab(prevTab => {
        const nextTab = (prevTab + 1) % tabsData.length;
        return nextTab;
      });
    }, 5000); // 5 segundos

    return () => clearInterval(interval);
  }, [tabsData.length]);

  return (
    <div className="qualidade-banner">
      {/* Container principal */}
      <div className="banner-container">
        {/* Background */}
        <div
          className="banner-background"
          style={{
            backgroundImage: `url(${tabsData[activeTab].backgroundImage})`
          }}
        ></div>

        {/* Título dentro do banner */}
        <div className="banner-header">
          <h2 className="banner-title">
            A EXCELÊNCIA ESTÁ NOS DETALHES
          </h2>
        </div>

        {/* Wrapper centralizado com flex */}
        <div className="banner-content-wrapper">
          {/* Menu lateral */}
          <div className="banner-menu">
            {tabsData.map((tab, index) => (
              <button
                key={tab.id}
                ref={el => menuItemsRefs.current[index] = el}
                className={`menu-item ${index === activeTab ? 'active' : ''}`}
                onClick={() => goToTab(index)}
              >
                <img
                  src={tab.icon}
                  alt={tab.title}
                  className="menu-icon-quality"
                />
                <span className="menu-text">{tab.title}</span>
              </button>
            ))}
          </div>

          {/* Banner principal */}
          <div className="banner-main">
            <div
              className={`banner-content ${tabsData[activeTab].type === 'image' ? 'certificados' : ''}`}
              style={{
                transform: tabsData[activeTab].type === 'image'
                  ? 'translateY(0)'
                  : `translate3d(0, calc(-50% + ${contentPosition}px), 0)`
              }}
            >
              {tabsData[activeTab].type === 'image' ? (
                <div className="certificados-image">
                  <img
                    src={tabsData[activeTab].image}
                    alt="Certificados Essentia Group"
                  />
                </div>
              ) : (
                <div className="content-box">
                  <p className="content-highlight">
                    {tabsData[activeTab].content.highlight}
                  </p>
                  <p className="content-description">
                    {tabsData[activeTab].content.description}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QualidadeBanner;